// 添加Skeleton导入
import { Skeleton } from '@/components/ui/skeleton';

/** 基础信息骨架屏组件 */
export function SkeletonBasicInformation() {
  return (
    <div className='w-full h-full overflow-hidden mb-6'>
      <div className='flex flex-wrap gap-5 mb-6'>
        {/* 用户ID字段骨架 */}
        <div className='w-80'>
          <Skeleton className='w-48 h-5 mb-2.5' />
          <Skeleton className='w-32 h-10' />
        </div>

        {/* 用户名字段骨架 */}
        <div className='w-80'>
          <Skeleton className='w-48 h-5 mb-2.5' />
          <Skeleton className='w-full h-10 mb-1.5' />
          <Skeleton className='w-64 h-3' />
        </div>

        {/* 邮箱字段骨架 */}
        <div className='w-80'>
          <Skeleton className='w-48 h-5 mb-2.5' />
          <Skeleton className='w-40 h-5' />
        </div>

        {/* 性别字段骨架 */}
        <div className='w-80'>
          <Skeleton className='w-48 h-5 mb-2.5' />
          <div className='flex space-x-4'>
            <Skeleton className='w-20 h-5' />
            <Skeleton className='w-20 h-5' />
          </div>
        </div>

        {/* 用户状态字段骨架 */}
        <div className='w-80 flex-shrink-0'>
          <Skeleton className='w-48 h-5 mb-2.5' />
          <Skeleton className='w-12 h-6' />
        </div>

        {/* 应用验证状态字段骨架 */}
        <div className='w-80'>
          <Skeleton className='w-48 h-5 mb-2.5' />
          <Skeleton className='w-24 h-5' />
        </div>

        {/* 创建日期字段骨架 */}
        <div className='w-80'>
          <Skeleton className='w-48 h-5 mb-2.5' />
          <Skeleton className='w-48 h-5' />
        </div>

        {/* 使用期限字段骨架 */}
        <div className='w-80'>
          <Skeleton className='w-48 h-5 mb-2.5' />
          <Skeleton className='w-48 h-5' />
        </div>
      </div>
    </div>
  );
}